import { AlertCircle, LoaderCircle, RefreshCw } from "lucide-react";
import { useMessages } from "../../i18n";
import { Button } from "./Button";

export function LoadingState({ label }: { label?: string }) {
  const t = useMessages();

  return (
    <div className="async" role="status">
      <LoaderCircle className="spin" size={22} aria-hidden="true" />
      <p>{label ?? t.app.printingSheet}</p>
    </div>
  );
}

export function ErrorState({
  message,
  retry,
}: {
  message: string;
  retry?: () => void;
}) {
  const t = useMessages();

  return (
    <div className="async async--error" role="alert">
      <AlertCircle size={22} aria-hidden="true" />
      <div>
        <strong>{t.app.sheetFailed}</strong>
        <p>{message}</p>
      </div>
      {retry ? (
        <Button variant="ghost" icon={<RefreshCw size={15} />} onClick={retry}>
          {t.app.retry}
        </Button>
      ) : null}
    </div>
  );
}
